import React, { createContext, useContext, useState } from 'react';

interface AppLibraryContextType {
  selectedCategory: string;
  setSelectedCategory: (category: string) => void;
}

const AppLibraryContext = createContext<AppLibraryContextType | undefined>(undefined);

export const useAppLibrary = () => {
  const context = useContext(AppLibraryContext);
  if (!context) {
    throw new Error('useAppLibrary must be used within AppLibraryProvider');
  }
  return context;
};

interface AppLibraryProviderProps {
  children: React.ReactNode;
}

export const AppLibraryProvider: React.FC<AppLibraryProviderProps> = ({ children }) => {
  const [selectedCategory, setSelectedCategory] = useState('all');

  return (
    <AppLibraryContext.Provider
      value={{
        selectedCategory,
        setSelectedCategory,
      }}
    >
      {children}
    </AppLibraryContext.Provider>
  );
};
